<template>
  <div>
    <!-- Add overlay div that appears when chatbot is open -->
    <div v-if="isChatbotOpen" class="chatbot-overlay" @click="closeChatbot"></div>
    
    <button class="chatbot-trigger" @click="toggleChatbot">
      <div class="icon-container">
        <img v-if="!isChatbotOpen" src="@/assets/images/chatbot8.svg" alt="Open Chat" class="trigger-icon">
        <img v-else src="@/assets/images/chatbot7.svg" alt="Close Chat" class="trigger-icon">
      </div>
    </button>
    <transition name="fade-slide">
      <Chatbot v-if="isChatbotOpen" @close="closeChatbot" />
    </transition>
  </div>
</template>

<script>
import Chatbot from './Chatbot.vue';

export default {
  name: 'ChatbotButton',
  components: {
    Chatbot
  },
  data() {
    return {
      isChatbotOpen: false
    }
  },
  methods: {
    toggleChatbot() {
      this.isChatbotOpen = !this.isChatbotOpen;
    },
    closeChatbot() {
      this.isChatbotOpen = false;
    }
  }
}
</script>

<style scoped>
/* Add overlay styles */
.chatbot-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black */
  z-index: 1000; /* Just below the chatbot button but above other content */
  /* animation: fade-in 0.3s ease-out; */
}

/* @keyframes fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
} */

.chatbot-trigger {
  position: fixed;
  bottom: 110px !important; 
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #F6601B;
  color: white;
  border: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2000;
  transition: transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275), 
              background-color 0.3s ease, 
              box-shadow 0.3s ease;
  overflow: hidden;
  will-change: transform, background-color, box-shadow;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  transition: transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  padding: 5px;
  will-change: transform;
}

.trigger-icon {
  width: 15px;
  height: 15px;
  object-fit: contain;
  transition: opacity 0.25s ease, transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  will-change: opacity, transform;
}

.chatbot-trigger:hover {
  background-color: theme('colors.orange.chatHover');
  transform: scale(1.08);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.chatbot-trigger:hover .icon-container {
  transform: rotate(8deg);
}

.chatbot-trigger:active {
  transform: scale(0.92);
  transition: transform 0.15s ease;
}

/* Animation for the chatbot */
.fade-slide-enter-active {
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1);
}

.fade-slide-leave-active {
  transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fade-slide-enter, .fade-slide-leave-to {
  transform: translateY(15px) scale(0.98);
  opacity: 0;
}

/* FAQ answer animations */
.faq-answer-enter-active {
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 500px;
  overflow: hidden;
}

.faq-answer-leave-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 0;
  overflow: hidden;
}

.faq-answer-enter, .faq-answer-leave-to {
  opacity: 0;
  max-height: 0;
  transform: translateY(-5px);
}
</style>